import { render, staticRenderFns } from "./r-item-shop-dialog.vue?vue&type=template&id=5e085a4c&scoped=true"
import script from "./r-item-shop-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-shop-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-shop-dialog.vue?vue&type=style&index=0&id=5e085a4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e085a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e085a4c')) {
      api.createRecord('5e085a4c', component.options)
    } else {
      api.reload('5e085a4c', component.options)
    }
    module.hot.accept("./r-item-shop-dialog.vue?vue&type=template&id=5e085a4c&scoped=true", function () {
      api.rerender('5e085a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-shop/r-item-shop-dialog.vue"
export default component.exports